import React from 'react';
import { SCROLL_ARROW_STYLES } from '../../constants/styles';

const ScrollArrows = ({ 
    mealType, 
    shouldShowArrows, 
    itemCount, 
    scrollState, 
    onScrollLeft, 
    onScrollRight 
}) => {
    if (!shouldShowArrows(itemCount, mealType)) return null;

    return (
        <>
            {/* Left Arrow */}
            {scrollState.canScrollLeft && (
                <div
                    style={{
                        ...SCROLL_ARROW_STYLES.base,
                        ...SCROLL_ARROW_STYLES.left
                    }}
                    onClick={() => onScrollLeft(mealType)}
                >
                    ←
                </div>
            )}

            {/* Right Arrow */}
            {scrollState.canScrollRight && (
                <div
                    style={{
                        ...SCROLL_ARROW_STYLES.base,
                        ...SCROLL_ARROW_STYLES.right
                    }}
                    onClick={() => onScrollRight(mealType)}
                >
                    →
                </div>
            )}
        </>
    );
};

export default ScrollArrows;